import { IAtributo } from 'contexts/@types/Layers';

export interface IAnalytesData {
  attribute: IAtributo;
  value: unknown;
}

export function isAnalytesAttribute(attribute: Pick<IAtributo, 'nm_coluna' | 'nm_alias'>): boolean {
  return (
    attribute.nm_coluna.trim().toLocaleLowerCase() === 'analitos' &&
    attribute.nm_alias.trim().toLocaleLowerCase() === 'analitos_json'
  );
}

export function parseAnalytesValue(value: unknown): unknown {
  if (typeof value === 'string') {
    const trimmedValue = value.trim();
    if (!trimmedValue) return value;

    try {
      return JSON.parse(trimmedValue);
    } catch {
      return value;
    }
  }

  return value;
}

export function getAnalytesData(
  attributes: IAtributo[],
  properties: Record<string, unknown> | null | undefined,
): IAnalytesData | null {
  const analytesAttribute = attributes.find(isAnalytesAttribute);
  if (!analytesAttribute) return null;

  const analytesEntry = Object.entries(properties ?? {}).find(
    ([attributeName]) =>
      attributeName.trim().toLocaleLowerCase() ===
      analytesAttribute.nm_coluna.trim().toLocaleLowerCase(),
  );

  return {
    attribute: analytesAttribute,
    value: parseAnalytesValue(analytesEntry?.[1]),
  };
}

export function filterAnalytesAttributes(attributes: IAtributo[]): IAtributo[] {
  return attributes.filter(attribute => !isAnalytesAttribute(attribute));
}

export function getFirstAnalyteRecord(value: unknown): Record<string, unknown> | null {
  if (Array.isArray(value)) {
    for (const item of value) {
      const record = getFirstAnalyteRecord(item);
      if (record) return record;
    }

    return null;
  }

  if (!value || typeof value !== 'object') return null;

  const record = value as Record<string, unknown>;
  if (Object.prototype.hasOwnProperty.call(record, 'amostra')) return record;

  for (const nestedValue of Object.values(record)) {
    const nestedRecord = getFirstAnalyteRecord(nestedValue);
    if (nestedRecord) return nestedRecord;
  }

  return null;
}
